import React, { useEffect, useRef, useState } from "react"
import { translate } from "../../base/i18n";
import { Audio } from "../../base/media";

const TEST_SOUND_PATH = "/sounds/ring.wav";

function TestingAudio({ t, deviceId, volume }) {
    const [ testing, setTesting ] = useState(false);
    const element = useRef();

    useEffect(() => {
        _setAudioSink();
    }, [deviceId]);

    const onClick = () => {
        setTesting(!testing);
    };

    const _setAudioSink = () => {
        element.current
            && deviceId
            && element.current.setSinkId(deviceId);
    }

    return (
        <>
            <button className={`btn btn_middle ${testing ? "btn_on" : "" }`} onClick={onClick}>{t("device.deviceTest")}</button>
            {testing && <Audio type="audio/wav" 
                ref={ element } 
                src={ TEST_SOUND_PATH } 
                volume={volume} 
            />}
        </>
    )
}

export default translate(TestingAudio);